import React, { Dispatch, SetStateAction } from 'react';


import { makeStyles } from 'tss-react/mui';
import { Box, Button, CustomSelect, Icon } from 'web-library';
import { useTranslation } from 'react-i18next';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { StatusCodes } from 'http-status-codes';
import { useGetAdmissionYears } from '../../../../api-refactored/exam-configuration/useGetAdmissionYears';

const useStyles = makeStyles()((theme) =>
({
  root:{},
  headerContainer: {
    marginTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      paddingBottom: theme.spacing(1),
    },
  },
  addIcon: {
    color: theme.color.icon.iconSelected,
  },
  addIconDisabled: {
    color: theme.color.link.linkDisabledBg01,
  },
  addButton: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1),
    },
  },
}));

interface AdmissionYearProps {
  selectedYear: number | null;
  setSelectedYear: Dispatch<SetStateAction<number | null>>;
  addButtonHandler: () => void;
  disabledAddButton?: boolean;
  setNoAccess: Dispatch<SetStateAction<boolean>>;
  hasCreateAuthority: boolean;
}

const { FORBIDDEN } = StatusCodes;

const mapAdmissionYearToDropdown = (admissionYear: number[]) =>
  admissionYear.map((value) => ({
    children: value,
    value,
    key: value,
  }));

const AdmissionYearAndAddButton = ({
  selectedYear,
  setSelectedYear,
  addButtonHandler,
  setNoAccess,
  disabledAddButton = false,
  hasCreateAuthority,
}: AdmissionYearProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { data: admissionYears } = useGetAdmissionYears({
    onSuccess: (data) => {
      if (data.length > 0) {
        setSelectedYear(data[0]);
      }
    },
    onError: (err) => {
      if (err.response?.status === FORBIDDEN) {
        setNoAccess(true);
      }
    },
  });

  if (!admissionYears) {
    return <></>;
  }

  return (
    <Box className={classes.headerContainer}>
      <CustomSelect
        isHeader
        displayEmpty
        onChange={(e) => setSelectedYear(e.target.value as number)}
        menuItems={mapAdmissionYearToDropdown(admissionYears)}
        variant="filled"
        value={selectedYear}
        placeholder={t('exam->>ExamConfiguration.SelectYearOfAdmission')}
        label={t('exam->>ExamConfiguration.YearOfAdmission')}
        rootClass={classes.root}
      />
      {hasCreateAuthority && (
        <Button
          id="button-add-exam-fees"
          variant="text"
          color="primary"
          startIcon={
            <Icon
              name={IconName.add}
              size="S"
              className={disabledAddButton ? classes.addIconDisabled : classes.addIcon}
            />
          }
          onClick={addButtonHandler}
          className={classes.addButton}
          disabled={disabledAddButton}
        >
          {t('exam->>ExamFeeConfiguration.AddExamFees')}
        </Button>
      )}
    </Box>
  );
};

export default AdmissionYearAndAddButton;
